/*
This is the place for all scripts that are going to be used on the site, but are not a part of visualdiet app
ie. handling a burger menu open/close.
*/

const menu = document.querySelector('#js-burger');
const overlay = document.querySelector('.js-overlay-content');
const downloadContent = document.querySelector('.download_content');

menu.addEventListener('click', e => {
    menu.classList.toggle('is-active')
    overlay.classList.toggle('is-visible')

    // Toggle aria-expanded attribute value when the overlay is shown/hidden.
    const ariaState = menu.getAttribute("aria-expanded");
    const newAriaState = ariaState == "true" ? "false" : "true";
    menu.setAttribute("aria-expanded", newAriaState);
})

console.log(downloadContent)

downloadContent.addEventListener('click', e => {
	e.preventDefault()
	let file = e.target.dataset.file

	if (window.ga !== undefined) {
    	let tracker = window.ga.getAll()[0]
   		tracker.send('event', 'content-download', file, new Date().toLocaleString('en-GB'))
  	}

  	window.open(e.target.href)
})


// WEBPACK FOOTER //
// ./js/scripts.js